var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.clickNavigateToLive}},[_vm._v("跳转直播页")]),_c('button',{on:{"click":_vm.clickNavigateToWebView}},[_vm._v("跳转webView")])])
}
var staticRenderFns = []

export { render, staticRenderFns }